// Libs
import React, { HTMLProps, ReactElement } from 'react';
import clsx from 'clsx';
// App
import styles from './user.module.scss';
import { Avatar, IconButton, Skeleton, Stack, Typography } from 'ui-components';
import AccountMenu from './account-menu';
import { formatAvatarInitials, formatUserName } from 'app-shared/lib/utils';
import { useAccount } from '@/fragments/_shared/account';

const User = (props: HTMLProps<HTMLDivElement>): ReactElement => {
  const { className, ...rest } = props;
  const { account, isAccountLoading } = useAccount();

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  if (isAccountLoading)
    return (
      <div className={clsx(className)}>
        <Stack direction="row" alignItems="center" spacing={1} p={0.5}>
          <Skeleton variant="circular" width={32} height={32} className={styles.circularSkeleton} />
          <Skeleton width="100%" />
        </Stack>
      </div>
    );

  if (!account)
    return (
      <div className={clsx(className)}>
        <Stack direction="row" alignItems="center" spacing={1} p={0.5}>
          <Skeleton variant="circular" width={32} height={32} className={styles.circularSkeleton} animation={false} />
          <Skeleton width="100%" animation={false} />
        </Stack>
      </div>
    );

  const userName = formatUserName(account.firstName, account.lastName);

  return (
    <div className={clsx(className)} {...rest}>
      <Stack direction="row" alignItems="center" justifyContent="flex-end" spacing={1}>
        <IconButton
          className={styles.iconButton}
          onClick={handleClick}
          size="small"
          aria-controls={open ? 'account-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
        >
          <Avatar>{formatAvatarInitials(userName)}</Avatar>
        </IconButton>
        <AccountMenu
          anchorEl={anchorEl}
          id="account-menu"
          open={open}
          onClose={handleClose}
          onClick={handleClose}
          user={account}
        />
        <div>
          <Typography
            variant="body2"
            component="div"
            fontWeight="500"
            maxWidth={172}
            textOverflow="ellipsis"
            overflow="hidden"
          >
            {account.firstName}
          </Typography>
        </div>
      </Stack>
    </div>
  );
};

export default User;
